import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationElementDirective } from '@app/directives/navigation-element.directive';
import { SettingsService } from '@app/services/settings.service';
import { SidebarSharedService } from '@app/services/sidebar-shared.service';
import { MenuItemKey, NavigationArea, NavigationMenuItem, NavigationMenuService } from 'library-explorer';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-native-navigation-bar',
    templateUrl: './native-navigation-bar.component.html',
    styleUrls: ['./native-navigation-bar.component.scss'],
    standalone: false
})
export class NativeNavigationBarComponent implements OnInit {
  @ViewChildren(NavigationElementDirective) public set elements(value: QueryList<NavigationElementDirective>) {
    this.hasNoLinks = value?.length === 0;
  }

  @Input() hide = false;

  public navigationMenu: NavigationMenuItem[] = [];

  public hasNoLinks = true;

  public readonly menuArea: typeof NavigationArea = NavigationArea;

  constructor(
    private readonly navigationMenuService: NavigationMenuService,
    private readonly sidebarSharedService: SidebarSharedService,
    private readonly router: Router,
    private readonly settingsService: SettingsService,
    private readonly element: ElementRef
  ) { }

  ngOnInit(): void {
    this.settingsService.getSettings().subscribe(settings => {
      this.element.nativeElement.style.setProperty('--lms-native-navigation-bar-active-background', settings.colors?.nativeNavigationBar?.activeBackgroundColor || '');
      this.element.nativeElement.style.setProperty('--lms-native-navigation-bar-active-text', settings.colors?.nativeNavigationBar?.activeTextColor || '');
      this.initializeNavigationMenu()
    });
  }

  private initializeNavigationMenu(): void {
    this.navigationMenu = this.navigationMenuService.getBottomNativeBarMenuItems();

    this.setUpActivateStateForCatalog();
  }

  private setUpActivateStateForCatalog(): void {
    const catalogMenuItem = this.navigationMenu.find(item => item.key === MenuItemKey.CATALOG);

    const catalogActive = this.sidebarSharedService.isCatalogMenuActive();
    this.setActiveStateForMenuItem(catalogMenuItem, catalogActive);

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe((event: NavigationEnd) => {
        const catalogActive = this.sidebarSharedService.isCatalogMenuActive();
        this.setActiveStateForMenuItem(catalogMenuItem, catalogActive);
      });
  }

  private setActiveStateForMenuItem(item: NavigationMenuItem, active = false): void {
    item.cssClass = active ? 'active' : null;
  }


}
